export default "__VITE_ASSET__DY071dWd__"